import {
  checkEmailActionType,
  checkEmailSuccessActionType,
  checkEmailFailureActionType,
} from 'actions/Users/checkEmail';

const INITIAL_STATE = {
  isPending: false,
  result: null,
};

export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case checkEmailActionType:
      return {
        isPending: true,
        result: null,
      };
    case checkEmailSuccessActionType:
      return {
        isPending: false,
        result: action.payload.result.data,
      };
    case checkEmailFailureActionType:
      return { ...INITIAL_STATE };
    default:
      return state;
  }
};
